<template>
    <div id="worksends" :class="$wait.any?'wait':''" class="styles-wait">
        <div v-if="!this.$store.state.headLoaded || !this.$store.state.coreLoaded" id="worksends-app-loader">
            <div id="worksends-app-loader-logo"></div>
            <div class="value-loader"></div>
        </div>
        <div v-else-if="$wait.any" id="worksends-loading-overlay"><div class="value-loader"></div></div>

        <router-view :key="routerViewKey"></router-view>
        <full-width-bar v-if="this.$store.state.demo.isDemo && this.$store.state.coreLoaded" position="bottom" type="demo"></full-width-bar>
        <full-width-bar v-if="!this.$store.state.demo.isDemo && this.$store.state.team && this.$store.state.team.detail.plan=='free'" position="bottom" type="on-demand"></full-width-bar>
        <full-width-bar v-if="!this.$store.state.demo.isDemo && this.$store.state.team && this.$store.state.team.detail.plan=='trial'" position="bottom" type="trial"></full-width-bar>

    </div>
</template>

<script>
import { hubBaseUrl } from '@/utils/hub-url';

export default {
    head: {
        link: [
            {
                rel: (process.env.NODE_ENV === 'production') ? 'preload stylesheet' : 'stylesheet',
                id: 'bookblock-shop-style-css',
                href: `${hubBaseUrl}/wp-content/themes/bookblock-shop/dist/bookblock_style.css`,
                type: 'text/css',
                as: 'style',
                media: 'all',
            },
            {
                rel: 'preload stylesheet',
                id: 'fonts-css',
                href: `${hubBaseUrl}/wp-content/themes/bookblock-shop/fonts.css`,
                type: 'text/css',
                as: 'style',
                media: 'all',
            },
        ],
        title() {
            return {
                inner: this.$route.meta.title || 'Bookblock HUB',
                complement: 'Bookblock HUB'
            };
        },
    },
	computed: {
		routerViewKey() {
			// don't use full path on marketplace physical, it bugs the filters when remounting on each route change
			return this.$route.name === 'marketplace-gifts-physical' ? 'marketplace-gifts-physical' : this.$route.fullPath;
		},
	},
    created: function () {
      this.$on('okHead', function () {
          this.$store.state.headLoaded = true;
      });
    }
};
</script>

<style lang="scss">
#worksends {
    @import "@/styles/fonts.scss";

    .styles-wait {
        display: none
    }
}
</style>
